import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'qumra-drawer',
  styleUrl: 'qumra-drawer.css',
  shadow: true,
})
export class QumraDrawer {
  @Prop() drawerDirection: 'left' | 'right' | 'top' | 'bottom' = 'left';
  @Prop() drawerTitle: string = 'العنوان';
  @Prop() isOpen: boolean = false;  // External control for opening/closing

  closeDrawer = () => {
    this.isOpen = false;
  };

  render() {
    if (!this.isOpen) return null;

    const isHorizontal = this.drawerDirection === 'left' || this.drawerDirection === 'right';
    const isLeft = this.drawerDirection === 'left';
    const isTop = this.drawerDirection === 'top';

    return (
      <div 
      onClick={this.closeDrawer}
        class={`fixed inset-0 flex ${isHorizontal ? 'justify-end' : 'items-end'}`} 
        style={{
          backgroundColor: '#0000003B',
          zIndex: '99999',
          justifyContent: isHorizontal ? (isLeft ? 'flex-start' : 'flex-end') : 'center',
          alignItems: !isHorizontal ? (isTop ? 'flex-start' : 'flex-end') : 'center',
        }}
      >
        <div 
          onClick={(event) => event.stopPropagation()} 
          class={`bg-white ${isHorizontal ? 'w-[405px] h-full' : 'w-full h-[405px]'} px-6 pt-8 flex flex-col gap-6`} 
          style={{
            zIndex: '99999',
            [isHorizontal ? (isLeft ? 'left' : 'right') : (isTop ? 'top' : 'bottom')]: '0',
            position: 'absolute'
          }}
        >
          <div class="flex justify-between">
            <div class="text-2xl font-bold">{this.drawerTitle}</div>
            <svg 
              class="cursor-pointer" 
              onClick={this.closeDrawer}
              width="32" 
              height="32" 
              viewBox="0 0 32 32" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path 
                d="M21.3332 10.6667L10.6665 21.3334M21.3332 21.3334L10.6665 10.6667" 
                stroke="#434A5B" 
                stroke-width="2" 
                stroke-linecap="round" 
              />
            </svg>
          </div>
          <div class="flex flex-col gap-4">
            <slot></slot>
          </div>
        </div>
      </div>
    );
  }
}
